import { Link } from "react-router-dom";
import { Lock, Palette } from "lucide-react";

/**
 * Shown when the workspace lacks Enterprise whitelabel entitlement.
 */
export default function WhitelabelUpgradePrompt({ plan = "studio", className = "" }) {
  const currentPlan = String(plan || "studio").trim() || "studio";

  return (
    <div className={`space-y-6 ${className}`.trim()} data-testid="whitelabel-upgrade-prompt">
      <h2 className="font-heading text-2xl flex items-center gap-2">
        <Palette size={20} /> White-label branding
      </h2>
      <div className="surface p-6 border border-[var(--border-default)] max-w-xl">
        <div className="flex items-start gap-3">
          <Lock size={18} className="text-[var(--text-tertiary)] shrink-0 mt-0.5" aria-hidden />
          <div>
            <p className="text-sm text-[var(--text-secondary)] leading-relaxed">
              Custom admin branding, logos, Google Fonts, dedicated hostnames, and full reseller mode are part of the
              {" "}
              <strong className="text-[var(--text-primary)]">Enterprise</strong>
              {" "}
              plan. Your workspace is on
              {" "}
              <strong className="text-[var(--text-primary)]">{currentPlan}</strong>
              .
            </p>
            <p className="text-xs text-[var(--text-tertiary)] mt-3 leading-relaxed">
              Event-level cover images and accents on public event pages are still available on Studio and Scale.
            </p>
            <Link to="/admin/billing" className="btn-primary text-xs mt-5 inline-flex">
              View plans &amp; upgrade
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
